import { useParams } from 'react-router-dom'

import { can } from '@/features/auth/permissions'
import { useSession } from '@/features/auth/use-session'

import { MarkdownDoc } from './MarkdownDoc'

/**
 * `/companies/:companyId/documentos/:documentId` y
 * `/projects/:projectId/documentos/:documentId`.
 *
 * El documento se abre DENTRO de la ficha, sin perder las tabs ni el header: es
 * una sección más de la empresa o del proyecto, no otra pantalla.
 */
export function DocumentRoute() {
  const { companyId = '', documentId = '' } = useParams()
  const { me } = useSession()

  return (
    <MarkdownDoc
      documentId={documentId}
      canWrite={can(me, 'document:write', companyId ? { companyId } : undefined)}
      backTo=".."
    />
  )
}
